import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'
import { replaceCustomCellIdentifier } from './replace-custom-cell-identifier.js'
import { replaceIdentifierExact } from './replace-identifier-exact.js'

export function replaceIdentifierValue(value: string, filePath: string, plan: RenamePlan): string {
  let next = value

  for (const rename of plan.customCells) {
    if (
      filePath === rename.columnsPath ||
      filePath === rename.oldPath ||
      filePath === rename.newPath
    ) {
      next = replaceCustomCellIdentifier(next, rename.before, rename.after)
    }
  }

  for (const rename of plan.fields) {
    next = replaceIdentifierExact(next, rename.before, rename.after)
  }

  return next
}
